module.exports = __webpack_public_path__ + "quilt1-level6.9cac8979.png";